"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.addNotification = exports.notificationsMerge = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _time = require("../../sorting/time");

var notificationsMerge = function notificationsMerge(newNotifications, stateNotifications) {
  var notificationsLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var mergedNotifications = stateNotifications ? (0, _concat.default)(stateNotifications).call(stateNotifications, newNotifications) : newNotifications;
  var sortedArray = (0, _time.sortArrayChronologically)(mergedNotifications, 'createdDateTime', _time.TimeSortingTypes.Descending);

  if (sortedArray.length > notificationsLimit) {
    var newArray = [];

    for (var i = 0; i < notificationsLimit; i++) {
      newArray[i] = sortedArray[i];
    }

    return newArray;
  } else {
    return sortedArray;
  }
};

exports.notificationsMerge = notificationsMerge;

var addNotification = function addNotification(state, notificationToAdd) {
  // Make it an array if it isn't one
  var notifications = (0, _isArray.default)(notificationToAdd) ? notificationToAdd : [notificationToAdd];
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    notifications: notificationsMerge(notifications, state.notifications, state.notificationsLimit)
  });
};

exports.addNotification = addNotification;